
import {Component, OnInit, ElementRef, ViewChild, AfterViewInit, ViewChildren, OnDestroy} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {fuseAnimations} from '../../../core/animations';
import {EventService} from '../../../core/services/event.service';
import {DataSource} from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject, Subscription} from 'rxjs';
import {distinctUntilChanged , debounceTime , map} from 'rxjs/operators';

import moment from 'moment';
moment.locale('de');
import {FuseUtils} from '../../../core/fuseUtils';
import {OrganizationsService} from '../../../core/services/organizations.service';
import {TargetGroupService} from '../../../core/services/targetGroup.service';
import {EventTypeService} from '../../../core/services/eventType.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {FusePerfectScrollbarDirective} from '../../../core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import {FuseConfigService} from '../../../core/services/config.service';
@Component({
    selector: 'released-event',
    templateUrl: './released-event.component.html',
    styleUrls: ['./released-event.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class ReleasedEventComponent implements OnInit , AfterViewInit, OnDestroy {
  events: FilesDataSource | any = [];
  displayedColumns = [ 'title' , 'type' , 'organization' , 'canton'  ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChildren(FusePerfectScrollbarDirective) scroll;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  initFinish = false;
  isOrganizer = false;
  isSubCounrty = false;

  private subscriptions =  new Subscription();

  constructor (private http: HttpClient , private eventService: EventService , private spinner: NgxSpinnerService ,
               private organizationService: OrganizationsService , private targetService: TargetGroupService ,
               public eventTypeSerice: EventTypeService , private fuseConfig: FuseConfigService) {

  }

  ngOnInit () {
    this.spinner.show();
    this.subscriptions.add(this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrganizer = true;
        this.isSubCounrty = false;
        this.displayedColumns = [ 'title' , 'type' , 'organization' , 'canton' , 'subscription', 'reserveCount', 'date' ];
      }
      if (res && res === 'subCountryAdmin') {
        this.isSubCounrty = true;
        this.isOrganizer = false;
      }
      this.eventService.getReleased().then(() => {
        this.events = new FilesDataSource(this.eventService , this.paginator , this.sort);
        // console.log(this.paginator);
        this.spinner.hide();
        observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
          debounceTime(150) ,
          distinctUntilChanged())
          .subscribe(() => {
            if (!this.events) {
              return;
            }
            this.events.filter = this.filter.nativeElement.value;
            this.paginator.firstPage();
          });
      });

      this.paginator.page.subscribe((result) => {
        this.scroll.last.scrollToTop();
      });
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  applyFilter(filterValue: string) {
    this.events.filter = filterValue.trim().toLowerCase();
  }

  ngAfterViewInit () {
  }

}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private eventService: EventService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.eventService.relisedEvents;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.eventService.onEventRelisedChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.eventService.relisedEvents.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'postcode':
          [ propertyA , propertyB ] = [ a.postcode , b.postcode ];
          break;
        case 'address':
          [ propertyA , propertyB ] = [ a.address , b.address ];
          break;
        case 'website':
          [ propertyA , propertyB ] = [ a.website , b.website ];
          break;
        case 'name':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;
        case 'country':
          [ propertyA , propertyB ] = [ a.country.name , b.country.name ];
          break;
        case 'organization':
          [ propertyA , propertyB ] = [ a.organization.name , b.organization.name ];
          break;
        case 'canton':
          [ propertyA , propertyB ] = [ a.city.name , b.city.name ];
          break;

      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
